import React from 'react'
import { useGetPlansDetails } from '../api/getPlansDetails'
import { ProductTypesWithoutBundle } from 'Types/ProductTypes'

export const useIsCancelProductFlow = () => {
  const { data: plansDetailsData } = useGetPlansDetails()

  // Allowed to cancel only if account has more then 1 product
  const isCancelProductFlowAllowed = React.useMemo(() => {
    const { plans } = plansDetailsData || {}
    return Boolean(plans && plans.length > 1)
  }, [plansDetailsData])

  const getProductId = (productName?: ProductTypesWithoutBundle): number => {
    if (!plansDetailsData || !productName) return 0
    const { plans } = plansDetailsData
    const product = plans?.find((plan) => plan.product.toLowerCase() === productName.toLowerCase())
    return product?.id || 0
  }

  return { isCancelProductFlowAllowed, getProductId }
}
